import { render } from "./index.vue?vue&type=template&id=147d5063&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=147d5063&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-147d5063"

export default script